import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import VendorMasterReadOnly from './VendorMasterReadOnly';
import VendorMasterEditable from './VendorMasterEditable';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import TextField from '@mui/material/TextField';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useGetAssetMastersQuery} from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import { useGetbrandmasterQuery } from '../../../features/brandmaster/brandmasterApiSlice';
import { useAddNewVendorMasterMutation, useDeleteVendorMasterMutation, useGetVendorMasterQuery, useUpdateVendorMasterMutation } from '../../../features/vendormaster/vendormasterApiSlice';




const Addcategform = styled.form`
  display: flex;
  margin:10px;
  align-items: center;
  justify-content:space-between;
`
const ChipDiv = styled.div`
  background-color: #d4d5d6;
  display: inline-block;
  font-size: 14px;
  border-radius: 30px;
  height: 30px;
  padding: 0 4px 0 1rem;
  display: inline-flex;
  align-items: center;
  margin: 0 0.3rem 0.3rem 0;
`

const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;
  justify-content:space-between;
  align-items:center;
`

const tableFontSize = 18;


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


const Modelno = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({
    id:"",
    vendorname:"",
    contactno:"",
    vendoremail:"",
    vendoraddress:""
  });
  const [newValue, setNewValue] = useState({
    vendorname:"",
    contactno:"",
    vendoremail:"",
    vendoraddress:""
  });
  const {vendormaster} = useGetVendorMasterQuery("vendormasterList", {
    selectFromResult: ({ data }) => ({
      vendormaster: data?.entities
    }),
  })

  const {assetmaster} = useGetAssetMastersQuery("appindasset", {
    selectFromResult: ({ data }) => ({
      assetmaster: data?.entities
    }),
  })
  const {brandmaster} = useGetbrandmasterQuery("brandmaster", {
    selectFromResult: ({ data }) => ({
      brandmaster: data?.entities
    }),
  })
  const [addVendor] = useAddNewVendorMasterMutation();
  const [updateVendor] =  useUpdateVendorMasterMutation();
  const [deleteVendor] = useDeleteVendorMasterMutation();

// Avoid a layout jump when reaching the last page with empty rows.
const emptyRows = 
page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};

const onSubmit = async (event) =>{
  event.preventDefault();
  console.log(newValue)
  try{
    let bodyobject ={...newValue};
    const foundAsset = vendormaster? Object.values(vendormaster).some(el => el.vendorname === newValue.vendorname):false;
    if(foundAsset){
      alert(`Model Number already exists in the Database`);
      let tempValue = {...newValue}
      tempValue.vendorname = "";
      tempValue.contactno = "";
      tempValue.vendoremail = "";
      tempValue.vendoraddress = "";
      setNewValue(tempValue);
      return
    }
    if(!newValue?.vendorname?.length){
      alert(`Please enter value for Vendor Name`)
      return;
    }
    if(!newValue?.contactno?.length){
      alert(`Please enter value for Contact Number`)
      return;
    }
    if(!newValue?.vendoremail?.length){
      alert("Please select value for Vendor Email");
      return
    }
    if(!newValue?.vendoraddress?.length){
      alert("Please select value for Vendor Address");
      return
    }
    const res = await addVendor(bodyobject) ;
    console.log(res)
    alert(`Vendor ${newValue.vendorname} with contact: ${newValue.contactno}, email: ${newValue.vendoremail} and address: ${newValue.vendoraddress} created successfully.`);
    let tempValue = {...newValue}
    tempValue.vendorname = "";
    tempValue.contactno = "";
    tempValue.vendoremail = "";
    tempValue.vendoraddress = "";
    setNewValue(tempValue);
  } catch(err){console.log(err)}
}

const onChangeAddValue= (event) =>{
  console.log(event.target.name)
  let tempValue = {...newValue}
  if(event.target.name){
    tempValue = {...tempValue, [event.target.name]:event.target.value}
  }
  setNewValue(tempValue);
}

const handleEditFormSubmit = async (e) =>{
  e.preventDefault();
  if(!editFormData.vendorname.length || !editFormData.contactno.length || !editFormData.vendoremail.length || !editFormData.vendoraddress.length){
    return alert("Please Enter all values before submitting");
  }
  if(Object.values(vendormaster).filter(elm => elm.id !== editFormData.id).map(x => x.vendorname).includes(editFormData.vendorname)){
    return alert("Vendor Name already exists in the database.")
  }
  try{
    setEditCategory(null);
    const response = await updateVendor(editFormData);

  }catch(err){}
}

const handleCancelClick = (e) => {
  let tempEditFormData = {...editFormData};
  tempEditFormData.id = "";
  tempEditFormData.modelno ="";
  tempEditFormData.asset = "";
  tempEditFormData.category = "";
  tempEditFormData.brand = "";
  setEditFormData(tempEditFormData);
  setEditCategory(null);
}
const onChangeEditVendor = (event, newValue) => {
  let tempEditFormData = {...editFormData};
  if(event.target.name){
    tempEditFormData = {...tempEditFormData, [event.target.name]:event.target.value}
  }
  setEditFormData(tempEditFormData);
}

const onClickEdit = (e,k,id) =>{
  let tempEditFormData = {...editFormData}
  tempEditFormData.id = id;
  tempEditFormData.vendorname = vendormaster[id].vendorname;
  tempEditFormData.contactno = vendormaster[id].contactno;
  tempEditFormData.vendoremail = vendormaster[id].vendoremail;
  tempEditFormData.vendoraddress = vendormaster[id].vendoraddress;
  setEditCategory(k+1);
  setEditFormData(tempEditFormData);
}

const handleDeleteClick = async (e,k, id) => {
  e.preventDefault();
  let body = {"id":id}
  const result = await deleteVendor(body);
}

useEffect(()=>{
  if(vendormaster){
    const vendorMasterArray = Object.values(vendormaster);
    setTabledata(vendorMasterArray);
  }
},[vendormaster])

console.log(brandmaster? Object.values(brandmaster): [])

  return (
    <>
    <HeadingWrap>
        <Span>Add Vendor</Span>
    </HeadingWrap>
    <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}> 
        <TextField
          id="outlined-basic"
          size='small'
          name='vendorname'
          onChange={onChangeAddValue}
          label="Enter New Vendor Name"
          value={newValue.vendorname || ""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"250px", height:"40px"}}
        />
        <TextField
          id="outlined-basic"
          size='small'
          name='contactno'
          onChange={onChangeAddValue}
          label="Enter Vendor Contact No."
          value={newValue.contactno || ""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"250px", height:"40px", marginLeft:"10px"}}
        />
        <TextField
          id="outlined-basic"
          size='small'
          name='vendoremail'
          onChange={onChangeAddValue}
          label="Enter Vendor email."
          value={newValue.vendoremail || ""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"250px", height:"40px", marginLeft:"10px"}}
        />
        <TextField
          id="outlined-basic"
          size='small'
          name='vendoraddress'
          onChange={onChangeAddValue}
          label="Enter Vendor Address."
          value={newValue.vendoraddress || ""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"400px", height:"40px", marginLeft:"10px"}}
        />        
         
        <SubmitButton type='submit'>Submit</SubmitButton>
      </Addcategform>

      {/* <Button2Div>
          <ExcelDownload data={downloadData} filename={"officeTypes"} sheetName={"sheet1"}/>
      </Button2Div>  */}
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
        <TableRow>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="center">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"17%"}}} align="left">Vendor Name</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"17%"}}} align="left">Contact No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"17%"}}}  align="left">Email</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}}  align="left">Address</TableCell>

          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}}align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
                <VendorMasterEditable row={row} k={key} editFormData={editFormData} 
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditVendor={onChangeEditVendor} newValue={newValue} tableFontSize={tableFontSize} SubmitButton={SubmitButton} assetmaster = {assetmaster}
                brandmaster = {brandmaster}
               />

                :<VendorMasterReadOnly row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} ChipDiv={ChipDiv} tableFontSize={tableFontSize} SubmitButton={SubmitButton}            
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>    
     </>
  )
}
export default Modelno